/* Vitrina por tienda — topmovil.com.gt
   marker: vitrina_por_tienda_v1_2026-08-31
   Julio: «que solo muestre lo que la tienda tiene, y que lo cambie rápido, tipo vitrina».
   La existencia por tienda ya la devuelve /sap/storefront-search (snapshot SAP cada 5 min);
   aca solo se elige la tienda y se pinta. La eleccion se recuerda para que el vendedor no
   la vuelva a escoger en cada busqueda. */
(function () {
  "use strict";
  var API = "https://sap-mcp.modularis.pro";
  var LS = "tm_vitrina_tienda";
  /* marker: el_id_compartido_duplico_la_vitrina_v1_2026-09-02
     Julio: «hay dos veces lo de la tienda en el home». Mi seccion se llamaba igual que
     una que ya existia (el carrusel «Descubre»), asi que los TRES bloques del home
     pasaron a renderizar esta vitrina con el mismo id repetido: solo la primera se
     llenaba y las otras dos quedaban de adorno. La raiz ya no se busca por id. */
  var raiz = document.querySelector("[data-tm-tienda]");
  if (!raiz) return;

  /* marker: la_vitrina_no_es_una_bodega_ordenada_v1_2026-09-03
     Una semilla por VISITA, no por busqueda: la vitrina se ve distinta cada vez que
     alguien entra, pero no se le baraja en la cara mientras cambia de tienda. */
  var semilla = Math.floor(Math.random() * 100000);

  var elTiendas = raiz.querySelector("[data-tiendas]");
  var conteos = {};   // {tienda: cuantos} de lo que se está buscando
  var elBusca = raiz.querySelector("[data-busca]");
  var elGrid = raiz.querySelector("[data-grid]");
  var elEstado = raiz.querySelector("[data-estado]");
  var tiendaActual = "";
  var pedido = 0;

  /* marker: la_tienda_recordada_no_manda_v1_2026-09-02
     Julio: «cuando la gente busca, no en automático». La vitrina abría en la tienda que el
     navegador recordaba de la visita anterior; si esa no tenía lo buscado, la persona veía
     «no hay» aunque otras nueve sí lo tuvieran, y le tocaba ir picando pastilla por pastilla.
     Regla acordada con él: si la tienda NO la eligió en esta visita, se salta sola a la que
     sí tiene. Si la eligió a propósito —está parada en ese punto— no se le mueve nada: se le
     nombran las otras, con cuántos hay, a un toque. */
  var elegidaAProposito = false;
  var saltosDados = 0, qDelSalto = null, avisoSalto = "";

  // Se puede llegar aca desde el buscador: /pages/vitrina?tienda=miraflores&q=defender+xt
  function param(n) {
    try { return new URLSearchParams(location.search).get(n) || ""; } catch (e) { return ""; }
  }

  function guardar(c) { try { localStorage.setItem(LS, c); } catch (e) {} }
  function recordar() { try { return localStorage.getItem(LS) || ""; } catch (e) { return ""; } }

  function estado(txt, tono) {
    elEstado.textContent = txt || "";
    elEstado.className = "tm-vit__estado" + (tono ? " tm-vit__estado--" + tono : "");
  }

  function money(n) {
    try { return "Q" + Number(n).toLocaleString("es-GT", { maximumFractionDigits: 0 }); }
    catch (e) { return "Q" + n; }
  }

  /* marker: el_disponible_se_perdia_v1_2026-09-03
     Julio: «el disponible se pierde para el cliente con el texto». Era la TERCERA linea
     gris seguida —nombre, precio, existencia— todas del mismo peso, asi que el dato que
     decide la compra se leia como pie de foto.
     Ahora comparte renglon con el precio, a la derecha: «cuanto cuesta / cuantos quedan»
     se leen de un golpe, y ademas se gana alto (entran mas productos por pantalla).
     Y el numero deja de ser un numero: 43 no significa nada, «Ultima» si. Cuando quedan
     pocas se dice, y se dice con el ROJO que ya usa el tema en los descuentos — no se
     inventa un color nuevo. El texto lo dice tambien, no solo el color. */
  function disponibilidad(u) {
    if (u <= 0)  return { txt: "Sin existencia", cls: " tm-vit__u--cero" };
    if (u === 1) return { txt: "Última",         cls: " tm-vit__u--poco" };
    if (u <= 3)  return { txt: "Quedan " + u,    cls: " tm-vit__u--poco" };
    return { txt: u + " en tienda", cls: "" };
  }

  function tarjeta(p) {
    var img = p.image ? '<img src="' + p.image + '" alt="" loading="lazy" width="300" height="300">'
                      : '<div class="tm-vit__sinfoto"></div>';
    var d = disponibilidad(p.unidades_en_tienda);
    return '<a class="tm-vit__item" href="' + p.url + '">' +
      '<div class="tm-vit__foto">' + img + '</div>' +
      '<div class="tm-vit__txt">' +
        '<span class="tm-vit__nombre">' + p.title + '</span>' +
        '<span class="tm-vit__linea">' +
          '<span class="tm-vit__precio">' + money(p.price) + '</span>' +
          '<span class="tm-vit__u' + d.cls + '">' + d.txt + '</span>' +
        '</span>' +
      '</div></a>';
  }

  function otrasConLo() {
    return Object.keys(conteos)
      .filter(function (t) { return t !== tiendaActual && conteos[t] > 0; })
      .sort(function (a, b) { return conteos[b] - conteos[a] || a.localeCompare(b); });
  }

  var ultima = null;   // la última respuesta, para repintar cuando lleguen los conteos

  function pintar(d) {
    ultima = d;
    if (!d.results || !d.results.length) {
      /* marker: el_vacio_no_es_un_callejon_v1_2026-09-02
         Julio: «está mostrando las tiendas que no se tiene el producto». Pasaba esto: la
         tienda elegida no tenía lo buscado y la página quedaba en blanco, con el aviso en
         letra chica al pie — aunque 10 tiendas sí lo tuvieran. Ahora el vacío ofrece la
         que más tiene, a un toque. Un «no hay» sin salida es una venta perdida. */
      var otras = otrasConLo();
      if (otras.length && !elegidaAProposito && saltosDados < 1) {
        saltosDados++;
        avisoSalto = "En " + d.tienda + " no había; te muestro " + otras[0] + ".";
        tiendaActual = otras[0];
        guardar(tiendaActual);
        pintarBarra();
        elGrid.innerHTML = "";
        buscar();
        return;
      }
      elGrid.innerHTML = otras.length
        ? '<div class="tm-vit__nohay">' +
            "<p>En <b>" + d.tienda + "</b> no hay de «" + d.query + "» ahorita. Sí hay en:</p>" +
            '<div class="tm-vit__otras">' +
              otras.slice(0, 3).map(function (t, i) {
                return '<button type="button" class="tm-vit__ir' +
                       (i ? " tm-vit__ir--alt" : "") + '" data-ir="' + t + '">' +
                       t + '<span class="tm-vit__n">' + conteos[t] + "</span></button>";
              }).join("") +
            "</div>" +
          "</div>"
        : "";
      estado(d.query
        ? ("En " + d.tienda + " no hay nada de «" + d.query + "» ahorita." +
           (d.hay_en_otras_tiendas ? " Sí hay en otras tiendas." : ""))
        : ("En " + d.tienda + " no hay existencia publicada ahorita."), "vacio");
      return;
    }
    /* marker: aqui_hay_poco_alla_hay_bastante_v1_2026-09-02
       Julio, midiendo: «estuche iphone 16» daba 2 en ShowRoom mientras Pradera tenia 26, y
       la persona no se enteraba — se llevaba la impresion de que casi no hay. Solo avisa
       cuando la diferencia es de verdad (el doble Y al menos 5 mas), para no gritar por
       26 contra 25 ni empujar a nadie de una tienda a otra por nada. */
    var extra = "";
    if (d.query) {
      var otras = otrasConLo(), mejor = otras[0];
      var aqui = (conteos[d.tienda] != null) ? conteos[d.tienda] : d.count;
      if (mejor && conteos[mejor] >= aqui * 2 && conteos[mejor] - aqui >= 5) {
        extra = '<div class="tm-vit__mas">También hay <b>' + conteos[mejor] + "</b> en " + mejor +
                '<button type="button" class="tm-vit__vermas" data-ir="' + mejor + '">Ver ahí →</button></div>';
      }
    }
    /* marker: el_home_no_es_el_catalogo_v1_2026-09-02
       En su propia pagina se muestran las 48; en el inicio eso hunde todo lo que viene
       abajo. Con tope, la vitrina asoma lo que hay y manda a verlo completo — llevandose
       la tienda elegida, para que la persona no la vuelva a escoger. */
    var tope = parseInt(raiz.getAttribute("data-maximo") || "0", 10) || 0;
    var lista = (tope > 0) ? d.results.slice(0, tope) : d.results;
    var verTodo = "";
    if (tope > 0 && d.results.length > tope) {
      verTodo = '<a class="tm-vit__todo" href="/pages/vitrina?tienda=' +
                encodeURIComponent(d.clave || "") + '">Ver los ' + d.results.length + " de " + d.tienda + " →</a>";
    }
    elGrid.innerHTML = extra + lista.map(tarjeta).join("") + verTodo;
    estado((avisoSalto ? avisoSalto + " " : "") +
           d.count + (d.count === 1 ? " producto" : " productos") + " en " + d.tienda +
           (d.query ? "" : " · escribí arriba para afinar"));
  }

  function buscar() {
    var q = (elBusca.value || "").trim();
    if (!tiendaActual) { estado("Elegí una tienda para ver lo que hay.", "vacio"); return; }
    /* sin texto NO se vacia: se pide la vitrina completa de esa tienda */
    if (q !== qDelSalto) { saltosDados = 0; qDelSalto = q; avisoSalto = ""; }
    var mio = ++pedido;
    estado(q ? ("Buscando en " + tiendaActual + "…") : ("Viendo lo que hay en " + tiendaActual + "…"));
    refrescarConteos(q);
    fetch(API + "/sap/buscar-en-tienda?q=" + encodeURIComponent(q) +
          "&tienda=" + encodeURIComponent(tiendaActual) + "&top=48&semilla=" + semilla)
      .then(function (r) { if (!r.ok) throw new Error("HTTP " + r.status); return r.json(); })
      .then(function (d) { if (mio === pedido) pintar(d); })
      .catch(function (e) {
        if (mio !== pedido) return;
        elGrid.innerHTML = "";
        estado("No se pudo consultar la existencia (" + e.message + "). Probá de nuevo.", "error");
      });
  }

  elGrid.addEventListener("click", function (ev) {
    var b = ev.target.closest("[data-ir]");
    if (!b) return;
    ev.preventDefault();
    tiendaActual = b.getAttribute("data-ir");
    elegidaAProposito = true;
    guardar(tiendaActual);
    pintarBarra();
    buscar();
  });

  var t;
  elBusca.addEventListener("input", function () { clearTimeout(t); t = setTimeout(buscar, 350); });
  elBusca.addEventListener("keydown", function (e) { if (e.key === "Enter") { e.preventDefault(); clearTimeout(t); buscar(); } });

  /* marker: la_barra_dice_donde_si_hay_v1_2026-09-02
     Julio: «está mostrando las tiendas que no se tiene el producto». El dato estaba bien;
     lo que fallaba es que las 18 pastillas se veían iguales, así que había que ir tocando
     una por una hasta dar con la que tenía. Ahora cada una dice cuántos hay ANTES de
     tocarla, las que no tienen se apagan, y las que sí van primero. */
  var todasLasTiendas = [];
  function pintarBarra() {
    var hayConteo = Object.keys(conteos).length > 0;
    var lista = todasLasTiendas.slice();
    if (hayConteo) {
      lista.sort(function (a, b) {
        return (conteos[b.tienda] || 0) - (conteos[a.tienda] || 0) ||
               a.tienda.localeCompare(b.tienda);
      });
    }
    elTiendas.innerHTML = lista.map(function (t) {
      var n = hayConteo ? (conteos[t.tienda] || 0) : null;
      var cls = "tm-vit__chip" + (t.tienda === tiendaActual ? " is-on" : "") +
                (hayConteo && !n ? " sin" : "");
      var num = (n !== null && n > 0) ? '<span class="tm-vit__n">' + n + "</span>" : "";
      var tit = (n === 0) ? ' title="Aquí no hay de lo que buscás"' : "";
      return '<button type="button" class="' + cls + '" data-t="' + t.tienda + '"' + tit + ">" +
             t.tienda + num + "</button>";
    }).join("");
    // al reordenar por cantidad, la elegida puede quedar lejos: se trae a la vista
    var on = elTiendas.querySelector(".tm-vit__chip.is-on");
    if (on && on.scrollIntoView) on.scrollIntoView({ block: "nearest", inline: "nearest" });
  }

  function refrescarConteos(q) {
    if (!q || q.length < 2) { conteos = {}; pintarBarra(); return; }
    fetch(API + "/sap/tiendas-con?q=" + encodeURIComponent(q))
      .then(function (r) { return r.json(); })
      .then(function (d) {
        conteos = {};
        (d.tiendas || []).forEach(function (t) { conteos[t.tienda] = t.cuantos; });
        pintarBarra();
        // los conteos llegan después del resultado: si quedó vacío, ahora sí se puede
        // ofrecer la tienda que sí tiene. Sin esto el vacío se queda mudo por una carrera.
        if (ultima) pintar(ultima);
      })
      .catch(function () {});
  }

  fetch(API + "/sap/tiendas")
    .then(function (r) { return r.json(); })
    .then(function (d) {
      var previa = recordar();
      var tiendas = d.tiendas || [];
      todasLasTiendas = tiendas;
      pintarBarra();
      elTiendas.addEventListener("click", function (ev) {
        var b = ev.target.closest("[data-t]");
        if (!b) return;
        tiendaActual = b.getAttribute("data-t");
        elegidaAProposito = true;
        guardar(tiendaActual);
        pintarBarra();
        buscar();
      });
      // manda la URL, luego lo que el vendedor uso la vez pasada, y de ultimo la primera
      var pedida = param("tienda").toLowerCase();
      var qUrl = param("q");
      if (qUrl) elBusca.value = qUrl;
      var elegir = tiendas.filter(function (t) {
                     return t.clave === pedida || t.tienda.toLowerCase() === pedida; })[0]
                || tiendas.filter(function (t) { return t.tienda === previa; })[0]
                || tiendas[0];
      if (elegir) {
        /* abrir en la tienda recordada NO es elegirla: por eso puede saltar sola. Llegar
           con ?tienda=... en el enlace SÍ lo es — alguien la nombro a proposito. */
        elegidaAProposito = !!(pedida && (elegir.clave === pedida ||
                                          elegir.tienda.toLowerCase() === pedida));
        tiendaActual = elegir.tienda;
        guardar(tiendaActual);
        pintarBarra();
        buscar();
      }
    })
    .catch(function (e) { estado("No se pudo cargar la lista de tiendas (" + e.message + ").", "error"); });
})();
